import type { ReadonlyDeep, SimplifyDeep } from 'type-fest';
import { z } from 'zod';

import { RawUIFolderSchema } from './raw-ui-folder';
import {
  allowVariablePlaceholders,
  variablePlaceholderSchema,
} from './raw-variable-placeholder';

export type RawProcessConfig = SimplifyDeep<
  ReadonlyDeep<z.infer<typeof RawProcessConfigSchema>>
>;

export const createRawProcessConfigSchema = (allowVariables = false) => {
  return allowVariablePlaceholders(
    z.object({
      id: z.string(),
      name: z.string().optional(),
      args: z
        .array(
          allowVariables ? z.string().or(variablePlaceholderSchema) : z.string()
        )
        .optional(),
      cwd: z.string().optional(),
      log: z.boolean().optional(),
      one_shot: z.boolean().optional(),
      disabled: z.boolean().optional(),
      notes: z.string().optional(),
      ui_folder: RawUIFolderSchema.optional(),
    }),
    allowVariables
  ).passthrough();
};

export const RawProcessConfigSchema = createRawProcessConfigSchema();
